export const DRAW_LINE_ITEM_COLUMN_KEY = {
  CATEGORY: 'category',
  REQUESTED: 'requested',
  BUDGET_REMAINING: 'budgetRemaining',
  PERCENT_COMPLETE: 'percentComplete',
};

export const DRAW_CHECKLIST_COLUMN_KEY = {
  ITEM_NAME: 'itemName',
  DETERMINATION: 'determination',
  RESULT: 'result',
  OVERRIDE: 'override',
};

export const DRAW_REVIEW_NOTES_FIELD_NAME = 'drawReviewNote';
